import { removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import { chain, DeleteSession } from "@insite/client-framework/Store/Context/Handlers/SignOut";

export const ClearCookies: Handler = () => {
    removeCookie("ymmContextMakeKey");
    removeCookie("ymmContextModelKey");
    removeCookie("ymmContextYearKey");
    removeCookie("ymmContextEngineKey");
    setCookie("ymmsearch", "false");
};

export const DispatchMakeSelected: Handler = ({ dispatch }) => {
    const untypedDispatch = dispatch as any;
    untypedDispatch({
        type: "Custom/Ymme/MakeSelected",
        parameter: "",
    });
};

export const DispatchModelSelected: Handler = ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    untypedDispatch({
        type: "Custom/Ymme/ModelSelected",
        parameter: "",
    });
};

export const DispatchYearSelected: Handler = ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    untypedDispatch({
        type: "Custom/Ymme/YearSelected",
        parameter: "",
    });
};

export const DispatchEngineSelected: Handler = ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    untypedDispatch({
        type: "Custom/Ymme/EngineSelected",
        parameter: "",
    });
};

export const DispatchToggleActive: Handler = ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    untypedDispatch({
        type: "Custom/Ymme/ToggleActive",
        parameter: false,
    });
};

addToChainAfter(chain, DeleteSession, ClearCookies);
addToChainAfter(chain, ClearCookies, DispatchMakeSelected);
addToChainAfter(chain, DispatchMakeSelected, DispatchModelSelected);
addToChainAfter(chain, DispatchModelSelected, DispatchYearSelected);
addToChainAfter(chain, DispatchYearSelected, DispatchEngineSelected);
addToChainAfter(chain, DispatchEngineSelected, DispatchToggleActive);
